export  function countDownFn(time) {
    var nowTime = +new Date();
    var inputTime = +new Date(time);
    var times = (inputTime - nowTime) / 1000;
    var d = parseInt(times / 60 / 60 / 24);
    d = d < 10 ? '0' + d : d;
    var h = parseInt(times / 60 / 60 % 24);
    h = h < 10 ? '0' + h : h;
    var m = parseInt(times / 60 % 60);
    m = m < 10 ? '0' + m : m;
    var s = parseInt(times % 60);
    s = s < 10 ? '0' + s : s;
    return d + '天' + h + '时' + m + '分' + s + '秒';
}


export function autoResponse(width = 750) {
    const target = document.documentElement
    console.log(target.clientWidth)
    if (target.clientWidth >= 1440) {
      target.style.fontSize = '16px'
      
    }else if(target.clientWidth > 1200  && target.clientWidth <= 1440){
        target.style.fontSize = '14px'
    }else if(target.clientWidth > 900 && target.clientWidth <= 1200){
        target.style.fontSize = '12px'
    }else if(target.clientWidth <= 900){
        target.style.fontSize = '10px'
    }// }else {
    //   target.style.fontSize = `${target.clientWidth / width * 100}px`
    //   console.log(target.style.fontSize)
    // }
  }
  
